import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {DoktorseReceptPayload} from '../types/DoktorseReceptPayload';
import {ApiHelper} from './api.helper';

@Injectable()
export class DoktorseReceptService {
  constructor(private http: HttpClient, private apiHelper: ApiHelper) {}

  public SendReceptRequest(
    payload: DoktorseReceptPayload
  ): Observable<DoktorseReceptPayload> {
    return this.http
      .post<DoktorseReceptPayload>(
        'https://www.varden.se/SendDoctorSeSMS',
        payload
      )
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }
}
